import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontSize: 12,
    fontFamily: '"Segoe UI", "Roboto", sans-serif',
    h6: {
      fontSize: '0.9rem',
      fontWeight: 500,
      margin: 0,
    },
    body2: {
      fontSize: '0.75rem',
      lineHeight: 1.2,
    },
    caption: {
      fontSize: '0.65rem',
    },
  },
  spacing: 6, // Reduced from default 8
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          padding: '8px',
          margin: '4px 0',
          boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '8px !important',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: '0.65rem',
          height: 20,
          padding: '2px 4px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '0.7rem',
          padding: '4px 8px',
          minHeight: 'auto',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        shrink: {
          transform: 'translate(14px, -6px) scale(0.75)',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: 4,
          paddingBottom: 4,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .MuiTabs-indicator': {
            height: 4, // Thicker line
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          textTransform: 'none',
          fontSize: '0.8rem',
        },
      },
    },
  },
});
